// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zWeq","buttons":"styles_buttons__1NTRx"};